// Generated by purs version 0.14.4
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
var mwith = function (dictMonoid) {
    return function (v) {
        return function (v1) {
            if (v instanceof Data_Maybe.Just) {
                return v1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return Data_Monoid.mempty(dictMonoid);
            };
            throw new Error("Failed pattern match at Data.Monoid.Extra (line 23, column 1 - line 23, column 58): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var mwhen = function (dictMonoid) {
    return function (v) {
        return function (v1) {
            if (!v) {
                return Data_Monoid.mempty(dictMonoid);
            };
            if (v) {
                return v1;
            };
            throw new Error("Failed pattern match at Data.Monoid.Extra (line 13, column 1 - line 13, column 49): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var munless = function (dictMonoid) {
    return function (v) {
        return function (v1) {
            if (v) {
                return Data_Monoid.mempty(dictMonoid);
            };
            if (!v) {
                return v1;
            };
            throw new Error("Failed pattern match at Data.Monoid.Extra (line 18, column 1 - line 18, column 51): " + [ v.constructor.name, v1.constructor.name ]);
        };
    };
};
var fromEmpty = function (dictEq) {
    return function (dictMonoid) {
        return function ($$default) {
            return function (value) {
                var $18 = Data_Eq.eq(dictEq)(value)(Data_Monoid.mempty(dictMonoid));
                if ($18) {
                    return $$default;
                };
                return value;
            };
        };
    };
};
export {
    mwhen,
    munless,
    mwith,
    fromEmpty
};
//# sourceMappingURL=index.js.map
